import React from 'react';
import { NewIcon } from '../../common/icon/new-icon';
import { NewIconNames } from '../../common/icon/new-icon-names';
import Tooltip from '../../common/tooltip/tooltip';
import { Button } from '@wix/design-system';

interface Props {
  onClick(): void;
  iconName: NewIconNames;
  tooltip: React.ReactNode;
  dataHook?: string;
}

export const ActionButton: React.FunctionComponent<Props> = ({
  tooltip,
  iconName,
  onClick,
  dataHook,
}: Props) => (
  <Tooltip content={tooltip} placement="bottom">
    <Button
      height="small"
      theme="icon-white"
      dataHook={dataHook}
      onClick={onClick}
    >
      <NewIcon name={iconName} />
    </Button>
  </Tooltip>
);
